import React from 'react';
import { Box, Dialog, IconButton, List, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Close, Menu } from '@mui/icons-material';
import { NavigationExternalLink } from '../../../components';
import { useTimezone } from '@uplift/contexts';
import { CalendarDateService } from '@uplift/services';


const ProviderMobileNavigationMenuContext = React.createContext<{
  open: boolean;
  onClose: () => void;
}>({
  open: false,
  onClose: () => null,
});

export const useProviderMobileNavigationMenuContext = () => {
  const context = React.useContext(ProviderMobileNavigationMenuContext);

  if (!context) {
    throw new Error('useProviderMobileNavigationMenuContext must be used within a ProviderMobileNavigationMenuContext.Provider');
  }

  return context;
};


const useStyles = makeStyles()({
  menuList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  }
});


export type ProviderMobileNavigationMenuProps = {
  children: NonNullable<React.ReactNode>;
};


export const ProviderMobileNavigationMenu: React.FC<ProviderMobileNavigationMenuProps> = (props) => {
  const timezone = useTimezone();
  const currentYear = CalendarDateService.date().tz(timezone).year();
  const { classes } = useStyles();
  const [ open, setOpen ] = React.useState(false);

  return (
    <ProviderMobileNavigationMenuContext.Provider
      value={{
        open,
        onClose: () => setOpen(false),
      }}
    >
      <>
        <IconButton onClick={() => setOpen(true)}>
          <Menu />
        </IconButton>
        <Dialog
          fullScreen
          open={open}
          onClose={() => setOpen(false)}
        >
          <Box display="flex" flexDirection="column" flex="1">
            <Box display="flex" justifyContent="flex-end" width="100%" px="12px" py="4px" boxSizing="border-box">
              <IconButton onClick={() => setOpen(false)}>
                <Close />
              </IconButton>
            </Box>
            <Box display="flex" flexDirection="column" flex="1">
              <List className={classes.menuList}>
                {props.children}
              </List>
            </Box>
            <Box p={3}>
              <Typography variant="body2" color="textSecondary">
                <NavigationExternalLink href="https://www.joinuplift.co/tos" data-testid="nav-profile-terms">Terms</NavigationExternalLink>
                · <NavigationExternalLink href="https://www.joinuplift.co/privacy" data-testid="nav-profile-privacy">Privacy</NavigationExternalLink>
                · UpLift © {currentYear}
              </Typography>
            </Box>
          </Box>
        </Dialog>
      </>
    </ProviderMobileNavigationMenuContext.Provider>
  );
};
